module.exports = __webpack_public_path__ + "img/invistaGlobal2.81830286.png";